/*
 * @Description: 混入websocket
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2023-05-26 13:23:25
 * @LastEditTime: 2024-03-25 11:08:38
*/
import { checkKeyboardContinuousChar } from '@/utils/validate'
const setPwd = {
  data() {
    const validateOldPasswd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入当前密码"));
      } else {
        callback();
      }
    };
    const validatePasswd = (rule, value, callback) => {
      // 必须包含大小写字母、数字、特殊字符
      const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&+=_！]).+$/
      //不能相同字符（如111、aaa）连续3位或3位以上
      const regex1 = /(\w)*(\w)\2{2}(\w)*/g

      if (value === '') {
        callback(new Error('请输入租户密码'));
      } else if (value.length < 8 || value.length > 30) {
        callback(new Error('租户密码必须在8~30个字符之间'));
      } else if (!regex.test(value)) {
        callback(new Error('密码必须包含大小写字母、数字、特殊字符[!@#$%^&+=_]'))
      } else if (regex1.test(value)) {
        callback(new Error('密码不能含有相同字符（例如111、aaa）连续3位或3位以上'))
      } else if (checkKeyboardContinuousChar(value)) {
        callback(new Error('密码不能含有标准键相邻按键组合（例如ASDFG,QWERTY）'))
      } else {
        // 不能连续字符（如123、abc）连续3位或3位以上
        for (let i = 1; i < value.length - 1; i++) {
          let firstIndex = value[i - 1].charCodeAt()
          let secondIndex = value[i].charCodeAt()
          let thirdIndex = value[i + 1].charCodeAt()
          if ((thirdIndex - secondIndex == 1) && (secondIndex - firstIndex == 1)) {
            callback(new Error('密码禁止设置递增的字母或数字（例如abc,123）连续3位或3位以上!'))
          } else {
            if (this.editPwdform.newPasswordConfirm !== "") {
              this.$refs.editPwdform.validateField("newPasswordConfirm");
            }
            callback()
          }
        }
      }
    };
    const validatePasswdCheck = (rule, value, callback) => {
      const reg = /(?=.*[A-Za-z])(?=.*[\d])(?=.*[~!@#$%^&*_])/

      if (value === "") {
        callback(new Error("您两次输入的密码不一致"));
      } else if (value != this.editPwdform.newPassword) {
        callback(new Error("您两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      // 强制修改密码
      editPwdDialog: false,
      editPwdform: {
        oldPassword: "11111111",
        newPassword: "",
        newPasswordConfirm: ""
      },
      editPwdformRules: {
        oldPassword: [
          { required: true, validator: validateOldPasswd, trigger: "blur" }
        ],
        newPassword: [
          { required: true, validator: validatePasswd, trigger: "blur" }
        ],
        newPasswordConfirm: [
          { required: true, validator: validatePasswdCheck, trigger: "blur" }
        ]
      },
    }
  },
  created() {
    let fixed = this.$route.params.fixed || JSON.parse(sessionStorage.getItem('fixed'))
    // console.log(1111111111, fixed)
    if (!fixed && fixed != null) {
      this.editPwdDialog = true
    } else {
      this.editPwdDialog = false
    }
  },
  methods: {
    editPwdConfirm() {
      this.$refs["editPwdform"].validate(valid => {
        if (valid) {
          let editPwdform = Object.assign({}, this.editPwdform);
          let editParams = {};
          // editParams.oldPassword = md5(editPwdform.oldPassword);
          // editParams.newPassword = md5(editPwdform.newPassword);
          this.request.post("/front/auth/updateUserPwd", { pwd: md5(editPwdform.newPassword) }).then(data => {
            if (data.code == 200) {
              this.msg.success("密码修改成功");
              this.editPwdDialog = false;
              this.editPwdform = {
                oldPassword: "11111111",
                newPassword: "",
                newPasswordConfirm: ""
              };
              this.request.get("/front/auth/logout").then((data) => {
                if (data.code == 200) {
                  this.msg.success("退出登录成功！");
                  this.storage.setSession("login", false)
                  this.resetSetItem('alarmList', null, 7)
                  this.$router.push("/login")
                  sessionStorage.setItem('fixed', null)
                } else if (data.code == 500) {
                  if (data.msg) {
                    this.msg.warn("退出登录失败，请联系管理员！");
                  } else {
                    this.msg.warn("Session过期，请重新登录!")
                    this.$router.push("/login");
                  }
                }
              });
            } else {
              this.msg.error(data.msg);
            }
          });
        } else {
          this.$message({
            type: "error",
            message: `请正确填写密码!`
          });
        }
      })
    },
  }
}
export default setPwd;
